import type { IExtractRouteParamMap, IRouteTranslation } from "../../types";
import { createBreadcrumbObject, createPaths, rebase } from "../../utils";

// Base route constant
const baseRoute = `/laboratory-management`;

// * Route configuration object for laboratory-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const laboratoryRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:laboratoryId`,
  edit: `${baseRoute}/edit/:laboratoryId`,
} as const;

// ! these are breadcrumbs translation not page title
const laboratoryRouteTranslation: IRouteTranslation<
  typeof laboratoryRoutesObj
> = {
  list: "laboratoriesManagement",
  create: "addLaboratory",
  edit: "editLaboratory",
  view: "viewLaboratory",
};

// * Extracts the route parameters for the laboratory route configuration.
export type ILaboratoryRouteParams = IExtractRouteParamMap<
  typeof laboratoryRoutesObj
>;

// * Path functions for the laboratory routes.
export const laboratoryPath = createPaths<
  typeof laboratoryRoutesObj,
  ILaboratoryRouteParams
>(laboratoryRoutesObj);

// * Breadcrumbs {translation and route} for the media routes
export const laboratoryBreadcrumbs = createBreadcrumbObject<
  typeof laboratoryRoutesObj
>(laboratoryRoutesObj, laboratoryRouteTranslation);
rebase(laboratoryBreadcrumbs, "list");
